import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { CrudeMappingModule } from "../store";
export var withCrudeMappingRoot = function withCrudeMappingRoot(_ref) {
  var selectState = _ref.selectState;
  return function (WrappedComponent) {
    return function (props) {
      var emptyObj = useMemo(function () {
        return {};
      }, []);
      return /*#__PURE__*/React.createElement(CrudeMappingModule, {
        context: emptyObj,
        state: selectState,
        "data-t-id": "crude-mapping-hocs"
      }, /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
        "data-t-id": "crude-mapping-hocs"
      })));
    };
  };
};